export const itemsPerPage = {
  book: 30,
  deal_home: 15,
  deal_panorama: 30,
  ticket_panorama: 20,
  product_stock: 30,
  task_planning: 30,
  appointment_planning: 30,
  reminder_planning: 30,
  note_planning: 30,
  ranking_commercial: 10,
  association_product: 50,
  navbar_notification: 15,
};
